<dsy-modal
  title-label="modalTitle"
  subtitle-label="Modal subtitle"
  confirm-button-label="Confirm"
  cancel-button-label="Cancel"
  custom-header
  z-index=1
  width="650px"
  closes-on-apply
  background-overlay-hidden
  [isOpen]="openModalClearAll"
  [cancelButtonInteractionFunction]="handleOpenClose"
  [preCloseButtonInteractionFunction]="handleOpenClose"
  [applyButtonInteractionFunction]="applyModal"
>
<div slot="header">
  <p class="fs-1">Template priority</p>
  <div class="row">
    <dsy-icon library="ionicons" name="warning-outline" class="mr-2 col-1" size="25px"></dsy-icon>
    <span class="mr-2 col-11">All priorities on main template will be set to “low” and the priorities based on event type will be set to “not assigned”. Are you sure?</span>
  </div>
</div>


</dsy-modal>
